import React from "react";
import "./ViewProfile.css";
import Header from "../layouts/Employee/Header";
import SubHeader from "../layouts/Employee/SubHeader";
import Profile from "../layouts/Employee/Profile";

const ViewProfile = () => {
  return (
    <>
      <Header />
      <SubHeader />
      <Profile />
    </>
  );
};

export default ViewProfile;
